import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AttributesApiService} from '../attributes/attributes-api.service';
import {AttributeManipulationGroupsApiService} from '../../settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {map} from 'rxjs/operators';
import {UrlQueryService} from '../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class FileRepositoryApiService {
  constructor(private http: HttpClient,
              private dicPropertyAttrApiService: AttributesApiService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService) { }


  readonly fileRepositoryUrl: string = 'identity/fileRepository';



  getFileRepositories(parameters: any = {}): Promise<any> {
    const generatedCustomersUrl = UrlQueryService.addQueryParameters(this.fileRepositoryUrl, parameters);
    return this.http.get(generatedCustomersUrl)
      .pipe(
        map((repositories: any) => {
          repositories.elements.forEach(repository => {
            this.addRelevantData(repository);
          });
          return repositories;
        })
      ).toPromise();
  }

  getFileRepository(id): Promise<any> {
    return this.http.get(`${this.fileRepositoryUrl}/${id}`).pipe(
      map((repository: any) => {
        this.addRelevantData(repository);
        return repository;
      })
    ).toPromise();
  }

  addFileRepository(file, fileRepository): Promise<any> {
    const formData = this.buildFormData(file, fileRepository);
    return this.http.post(this.fileRepositoryUrl, formData).toPromise();
  }

  editFileRepository(file, fileRepository): Promise<any> {
    const url = `${this.fileRepositoryUrl}/${fileRepository.id}`;
    const formData = this.buildFormData(file, fileRepository);
    return this.http.put(url, formData).toPromise();
  }

  deleteFileRepository(id): Promise<any> {
    return this.http.delete(`${this.fileRepositoryUrl}/${id}`).toPromise();
  }

  testAzureStorageConnection(fileRepository): Promise<any> {
    const url = `${this.fileRepositoryUrl}/azure/test`;
    const formData = this.buildFormData(null, fileRepository);
    return this.http.post(url, formData).toPromise();
  }
  validateLocalFile(fileRepository): Promise<any> {
    const url = `${this.fileRepositoryUrl}/localFile/test`;
    const formData = this.buildFormData(null, fileRepository);
    return this.http.post(url, formData).toPromise();
  }

  prepareDataForFileRepositoryAdd(): Promise<any> {
    const fileRepository = {name: '', delimiter: ',', isFileHasHeaders: true, isNameUnique: false, dicAttrMapping: []};

    return Promise.all([fileRepository, this.dicPropertyAttrApiService.getAttributes(),
      this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().toPromise()]);
  }

  prepareDataForFileRepositoryEdit(fileRepositoryId: number): Promise<any> {
    return Promise.all([
      this.getFileRepository(fileRepositoryId),
      this.dicPropertyAttrApiService.getAttributes(),
      this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().toPromise()]);
  }

  private buildFormData(file, fileRepository): any {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileRepositoryJson', new Blob([JSON.stringify(fileRepository)], {type: 'application/json'}));
    return formData;
  }

  private addRelevantData(repository): void {
    repository.unique = repository.isNameUnique ? -1 : repository.uniquePropertyId;
    const nameProp = {
      dicAttrId: -1,
      dicAttrName: 'Name',
      fileRepositoryAttrName: repository.nameFileMapping,
      fileRepositoryAttrLocation: repository.nameFileLocation,
      normalizationGroupId: null
    };

    if (!!repository.nameFileMapping || !!repository.nameFileLocation) {
      repository.dicAttrMapping.unshift(nameProp);
    }
  }

}
